import codeMessage from './codeMessage'
//import AutoDismissAlert from '../components/CommonComponents/AutoDismissAlert'
const successHandler=(response)=>{
 
    // const fnAutoDismissAlert=(keyVal,varientVal,messageVal,durationVal)=>{
    //     console.log("keyVal:::1",keyVal)
    //   return (<AutoDismissAlert keyVal={keyVal} varientVal={varientVal} messageVal={messageVal} durationVal={durationVal}/>)
    // }

    const {data}=response;
   //console.log("data.success",data.message)
    if(data && response.status===200)
    {
        //const message= data.message;
       // console.log("successText:::message",response.message)
        const successText=codeMessage[response.status];
        return successText;
       // console.log("successText",successText)
       // fnAutoDismissAlert('success','success',successText,'3000')
    }
    else
    {
        const message=response.message && data.message;
        const errorText=message || codeMessage[response.status];
        return errorText;
       // fnAutoDismissAlert('info','info',errorText,'3000')

    }

  //return (<>{response.status===200?fnAutoDismissAlert('success','success',codeMessage[response.status],'3000'):fnAutoDismissAlert('info','info',codeMessage[response.status],'3000')}</>)



}
export default successHandler;